export function verifyEmail(email = "") {
  // simple RFC822 compliant regular expression for email-validation
  // @see https://www.formget.com/regular-expression-for-email
  const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRegEx.test(String(email).toLocaleLowerCase());
}
